import axios from 'axios';
import Observer from '../../common/scripts/observer';
import {Utils} from '../../common/scripts/utils';

const observer = new Observer();

class Form {
    init(options) {
        this.wrapper = options.target;
        this.popupInstance = options.popupInstance || null;
        this.form = options.target.querySelector('form');
        this.isCustomHide = this.form.dataset.customHide || false;
        this.isVaildation = 'validate' in this.form.dataset;
        this.successMessage = options.successMessage;
        this.action = this.form.getAttribute('action');
        this.messageBot = this.form.querySelector('[name="message_bot"]');
        this.readyClass = 'is-ready';
        this.showClass = 'is-active';
        this.errorClass = 'is-error';
        this.disabledClass = 'is-disabled';
        this.hideClass = 'is-hide';
        this.fieldsData = [...this.form.querySelectorAll('[data-field-name]')] || false;

        this._getElements();
        this._subscribes();
        this._bindEvents();
        this._setHiddenInputs();
        this._setHiddenUrl();
    }

    /**
     * Метод получает дом элементы.
     * @private
     */
    _getElements() {
        this.submit = this.form.querySelector('.j-form-submit');
        this.repeatButtons = Array.from(this.wrapper.querySelectorAll('.j-form-repeat'));
        this.submitText = this.submit.querySelector('span');
        this.submitSendText = this.submit.dataset.sendText;
        this.submitSuccessText = this.submit.dataset.successText;
        this.submitErrorText = this.submit.dataset.errorText;
        this.formId = this.form.getAttribute('id') || '';
        this.searcherForm = this.form.classList.contains('j-searcher-result-form');
        this.majorTiedField = this.form.querySelector('.j-tied-major') || null;
        this.dependentTiedField = this.form.querySelector('[data-validate-email]') || null;
        this.formTitle = this.form.querySelector('.form__title')?.innerHTML || null;

        if (this.successMessage) {
            this.successMessageWrap = this.wrapper.querySelector('.j-form-success');
            this.errorMessageWrap = this.wrapper.querySelector('.j-form-error');
        }
    }

    _subscribes() {
        if (this.isVaildation) {
            observer.subscribe('formIsValid', (form) => {
                if (form === this.form) {
                    this._send();
                }
            });
        }
    }

    /**
     * Метод навешивает обработчики событий.
     * @private
     */
    _bindEvents() {
        if (!this.isVaildation) {
            if (this.submit) {
                this.submit.addEventListener('click', (event) => {
                    event.preventDefault();
                    this._send();
                });
            }
        }

        this.repeatButtons.forEach((button) => {
            button.addEventListener('click', () => {
                this._showRepeatForm();
            });
        });

        this._bindUXSevents();
    }

    _bindUXSevents() {
        const closeFormBtn = document.querySelector('.j-uxs-close-form');

        if (closeFormBtn && window.UXS) {
            closeFormBtn.addEventListener('click', () => {
                window.UXS.sendEvent('userClosedContactForm');
            });
        }

        if (this.majorTiedField && this.dependentTiedField) {
            this.majorTiedField.addEventListener('change', () => {
                if (this.majorTiedField.checked) {
                    this.dependentTiedField.setAttribute('data-validate-required', 'true');
                } else {
                    this.dependentTiedField.removeAttribute('data-validate-required');
                }
            });
        }
    }

    /**
     * Метод отправляет данные на сервер.
     * @private
     */
    _send() {
        if (this._isAllReady()) {
            return;
        }

        this._insertAntiSpam();
        this.formData = new FormData(this.form);

        this.formDataObject = {};
        this.formData.forEach((value, key) => {
            this.formDataObject[key] = value;
        });
        this._insertButtonText(this.submitSendText);
        this.fieldsData = [...this.form.querySelectorAll('[data-field-name]')];

        this.submit.setAttribute('disabled', 'disabled');

        axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        axios.post(this.action, this.formData)
            .then((response) => {
                const status = response.data.success;

                if (status) {
                    this._sendIsSuccess();

                    if (this.fieldsData && this.fieldsData.length) {
                        this._sendToComagic();
                    }

                    if (this.searcherForm) {
                        this._sendToGA();
                        this._sendToYM();
                    }
                } else {
                    throw new Error('Ошибка на сервере');
                }
            })
            .catch((err) => {
                this._sendIsError();
                console.error(err);
            })
            .then(() => {
                this.submit.removeAttribute('disabled');
            });
    }

    _isAllReady() {
        return this.wrapper.classList.contains(this.readyClass);
    }

    /**
     * Метод вызывается при успешной отправке запроса.
     * @private
     */
    _sendIsSuccess() {
        // форма отправлена - заменяем кнопки в попапе конструктора
        const popupBackLink = document.querySelector('.j-popup__back') || null;
        const forwardLinks = Array.from(document.querySelectorAll('.j-popup__forward'));

        if (forwardLinks.length > 1) {
            forwardLinks.forEach((link) => {
                link.classList.toggle('popup__close-hidden');
            });
        }

        if (popupBackLink) {
            popupBackLink.style.display = 'none';
        }

        this.errorMessageWrap.classList.remove(this.showClass);
        this.submit.classList.remove(this.errorClass);

        this._showSuccessMessage();
        this._insertButtonText(this.submitSuccessText);
        this.submit.classList.add(this.disabledClass);
        this._sendGAGoals();
    }

    /**
     * Метод вызывается при ошибке отправки запроса.
     * @private
     */
    _sendIsError() {
        this._insertButtonText(this.submitErrorText);
        this.submit.classList.add(this.errorClass);

        this._showErrorMessage();
    }

    /**
     * Отправляет цели в GA при успешной отправке формы
     * @private
     */
    _sendGAGoals() {
        if (window.gtag && this.submit.classList.contains('j-wish-success')) {
            window.gtag('event', 'success_callback_form', {
                // eslint-disable-next-line
                send_to: 'G-LLQN03TWXX',
                place  : 'search'
            });
        }
    }

    /**
     * Показывает сообщение об успешной отправкой формы.
     * @private
     */
    _showSuccessMessage() {
        this.wrapper.classList.add(this.readyClass);
        this.successMessageWrap.classList.add(this.showClass);

        if (this.isCustomHide) {
            this.form.classList.add(this.hideClass);
        } else {
            Utils.hide(this.form);
        }

        observer.publish('successForm');
    }

    /**
     * Показывает сообщение об ошибке
     * @private
     */
    _showErrorMessage() {
        this.wrapper.classList.add(this.readyClass);
        this.successMessageWrap.classList.remove(this.showClass);
        this.errorMessageWrap.classList.add(this.showClass);

        if (this.isCustomHide) {
            this.form.classList.add(this.hideClass);
        } else {
            Utils.hide(this.form);
        }

        observer.publish('errorForm');
    }

    /**
     * Повторно показывает форму, скрывая успех/ошибку
     * @private
     */
    _showRepeatForm() {
        this.wrapper.classList.remove(this.readyClass);
        this.successMessageWrap.classList.remove(this.showClass);
        this.errorMessageWrap.classList.remove(this.showClass);

        if (this.isCustomHide) {
            this.form.classList.remove(this.hideClass);
        } else {
            Utils.show(this.form);
        }
    }

    /**
     * Метод вставляет текст в кнопку сабмит.
     * @param {string} text - необходимый текст.
     * @private
     */
    _insertButtonText(text) {
        Utils.clearHtml(this.submitText);
        Utils.insetContent(this.submitText, text);
    }

    /**
     * Метод вставляет скрытое поле с антиспамом
     */
    _insertAntiSpam() {
        if (this.messageBot) {
            const minRandom = 1;
            const maxRandom = 10;

            this.messageBot.value = `nospam ${Utils.random(minRandom, maxRandom)}`;
        }
    }

    /**
     * Создает новый элемент input
     * @param {string} name - имя нового поля
     * @param {string} value - значение поля
     * @param {boolean} hidden - должно ли быть поле скрытым
     * @returns {HTMLElement} - новый элемент
     * @private
     */
    _createInput(name, value, hidden = false) {
        const input = document.createElement('input');

        input.name = name;
        input.value = value;
        input.hidden = hidden;

        return input;
    }

    /**
     * Устанавливает данные скрытому инпуту исходя из таргета попапа
     * @private
     */
    _setHiddenInputs() {
        if (!this.popupInstance || !this.popupInstance.currentTarget) {
            return;
        }

        const inputs = this.popupInstance.currentTarget.dataset.inputs;

        if (inputs) {
            const inputsArray = inputs.split(',');

            for (const item of inputsArray) {
                const data = item.split(':');
                const input = this.form.querySelector(`input[name="${data[0]}"]`);

                if (input) {
                    input.value = data[1];
                }
            }
        }

        const finishingInputData = this.popupInstance.currentTarget.dataset.finishingInput;

        if (finishingInputData) {
            const finishingInput = this._createInput('finishing', finishingInputData, true);

            this.form.insertBefore(finishingInput, this.form.firstChild);
        }
    }

    /**
     * При необходимости устанавливает текущий url в скрытый инпут
     * @private
     */
    _setHiddenUrl() {
        const input = this.form.querySelector('input[name=url]');

        if (input) {
            input.value = window.location.href;
        }
    }

    /**
     * Отправляет данные в Comagic
     */
    _sendToComagic() {
        if (typeof window.Comagic !== 'undefined' && typeof window.Comagic.addOfflineRequest !== 'undefined') {
            const objectFromData = {};

            this.fieldsData.forEach((field) => {
                objectFromData[field.dataset.fieldName] = field.value;
            });

            // eslint-disable-next-line
            objectFromData['form_name'] = this.formTitle;

            if (!Object.keys(objectFromData).length) {
                return;
            }

            window.Comagic.addOfflineRequest(objectFromData);
        }
    }

    /**
     * Отправляет цель в Гугл Аналитику
     * @private
     */
    _sendToGA() {
        const finalPlan = this.form.querySelector('input.flatFinalPlan')?.value || null;

        if (window.gtag) {
            if (finalPlan) {
                try {
                    window.gtag('event', 'constructor_send', {
                        // eslint-disable-next-line
                        send_to : 'G-LLQN03TWXX',
                        // eslint-disable-next-line
                        tip_plan: finalPlan
                    });
                    // eslint-disable-next-line
                    console.log('constructor_send with plan', finalPlan);
                } catch (error) {
                    console.error(error);
                }
            } else {
                try {
                    window.gtag('event', 'constructor_send', {
                        // eslint-disable-next-line
                        send_to : 'G-LLQN03TWXX'
                    });
                    // eslint-disable-next-line
                    console.log('constructor_send');
                } catch (error) {
                    console.error(error);
                }
            }
        }
    }

    /**
     * Отправляет цель в Я. Метрику
     */
    _sendToYM() {
        if (window.ym) {
            window.ym(91302277, 'reachGoal', 'Button_get_plan');
        }
    }
}

export default Form;
